import { generateImageData } from '@/components/atoms/media/umbracoMediaElementPropsFactory'
import { Navigation, MenuItem } from './navigation'
import { GetUmbracoBaseUrl } from '@/utils/urlHelpers'

function NavigationFactory({
  navigationData,
  pageHierarchyInfo,
}: {
  navigationData: any
  pageHierarchyInfo: any
}): JSX.Element {
  const currentHomePath = pageHierarchyInfo.breadCrumbTrail[0].path
  const isHomePage = currentHomePath === '/'

  const subHomePaths: string[] = navigationData?.items
    ?.filter((item: any) => item.contentType === 'subHomePage')
    .map((item: any) => item.route.path)

  const menuItems: Array<MenuItem> = navigationData?.items
    ?.filter((item: any) => {
      const itemPath: string = item.route.path
      const contentType: string = item.contentType

      if (contentType === 'homePage' || contentType === 'subHomePage') {
        return false
      }

      const matchingSubHomes = subHomePaths.filter((subHome: any) =>
        itemPath.startsWith(subHome),
      )

      const isSubHomeItem = matchingSubHomes.length > 0

      return (
        (isSubHomeItem && matchingSubHomes[0] === currentHomePath) ||
        (!isSubHomeItem && currentHomePath === '/')
      )
    })
    ?.map((item: any) => ({
      label: item.properties?.navigationLabel
        ? item.properties?.navigationLabel
        : item.name,
      url: item.route.path,
    }))

  const topLeftMenuItems: any[] = navigationData?.items
    ?.filter(
      (item: any) =>
        item.contentType === 'subHomePage' || item.contentType === 'homePage',
    )
    .map((item: any) => ({
      label: item.properties?.navigationLabel
        ? item.properties?.navigationLabel
        : item.name,
      url: item.route.path,
      isCurrentHome:
        pageHierarchyInfo.breadCrumbTrail[0].path === item.route.path,
    }))

  const currentHomes = navigationData?.items?.filter(
    (item: any) =>
      (item.contentType === 'subHomePage' || item.contentType === 'homePage') &&
      pageHierarchyInfo.breadCrumbTrail[0].path === item.route.path,
  )

  const topRightMenuItems =
    currentHomes.length === 0
      ? []
      : currentHomes[0].properties?.topRightNavigationItems?.map(
          (item: any) => ({
            label: item?.title,
            target: item?.target,
            url: item?.url,
          }),
        )
  const companyLogo = navigationData.items[0].properties.navigationLogo
  const companyLogoProps = generateImageData(
    { image: companyLogo },
    GetUmbracoBaseUrl(),
  )

  const searchUrl: MenuItem[] =
    currentHomes.length === 0
      ? []
      : currentHomes[0].properties?.searchUrl?.map((item: any) => ({
          label: item?.title,
          url: item?.route?.path,
        }))

  return (
    <Navigation
      menuItems={menuItems}
      topMenuItems={{
        left: topLeftMenuItems,
        right: topRightMenuItems,
      }}
      companyLogo={companyLogoProps}
      hasTopLevelNavigation={true}
      searchPageUrl={searchUrl}
      isHomePage={isHomePage}
    />
  )
}
export default NavigationFactory
